<template>
  <div class="block">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      :inline="true"
      label-width="100px"
      size="mini"
      style="margin:15px;width:80%;min-width:800px;"
    >
      <el-form-item style="text-align:left">
        <strong>个人信息</strong>
      </el-form-item>
      <br />
      <el-form-item label="姓名" prop="name">
        <el-col>
          <el-input v-model="form.name"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="form.phone"></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="idcard">
        <el-input v-model="form.idcard"></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="form.email"></el-input>
      </el-form-item>
      <el-form-item label="地址" prop="addr">
        <el-input v-model="form.addr" style="width:510px"></el-input>
      </el-form-item>
      <el-col :span="24" style="text-align:center">
      <el-form-item>
        <el-button type="primary" @click="onSubmit('form')">立即修改</el-button>
      </el-form-item>
       </el-col>
    </el-form>

    <!-- <el-form-item>
            <strong>收件地址</strong>
        </el-form-item><br>
        <el-form-item label="区域">
            <el-cascader
            style="width:196px"
                :options="options"
                v-model="selectedOptions"
                @change="handleChange">
             </el-cascader>
        </el-form-item>   
         <el-form-item label="详细地址"> 
			<el-input  v-model="form.visit_unit" style="width:510px"></el-input>
		</el-form-item> <br>   
    <el-col :span="24" style="text-align:center">-->
  </div>
</template>

<script>
import { RequestPost } from "../../api/api";
import { PageSize } from "../../api/api";
import { RequestGet } from "../../api/api";
import {
  provinceAndCityData,
  regionData,
  provinceAndCityDataPlus,
  regionDataPlus,
  CodeToText,
  TextToCode
} from "element-china-area-data";
export default {
  data() {
    return {
      form: {
        name: "",
        idcard: "",
        phone: "",
        email: "",
        addr: ""
      },
      rules: {
        name: [
          {
            required: true, //是否必填
            message: "姓名不能为空", //规则提示
            trigger: "blur" //何事件触发
          }
        ],
        phone: [
          {
            required: true, //是否必填
            message: "手机号不能为空", //规则提示
            trigger: "blur" //何事件触发
          },
          {
            pattern: /^1[34578]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur"
          }
        ],
        idcard: [
          {
            required: true, //是否必填
            message: "身份证不能为空", //规则提示
            trigger: "blur" //何事件触发
          },
          {
            pattern: /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/,
            message: "请输入正确的身份证号",
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true, //是否必填
            message: "邮箱不能为空", //规则提示
            trigger: "blur" //何事件触发
          },
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: "请输入正确的邮箱",
            trigger: "blur"
          }
        ],
        addr: [
          {
            required: true, //是否必填
            message: "地址不能为空", //规则提示
            trigger: "blur" //何事件触发
          }
        ]
      },
      options: regionData,
      selectedOptions: [],
      page: {
        pageSize: PageSize, //一页显示的条数
        criteria: ""
      }
    };
  },
  methods: {
    loadData() {
      this.page.criteria = sessionStorage.getItem("loginName");
      RequestGet("/customer/getCustomerList", this.page)
        .then(response => {
          if (response.code == "0000") {
            this.form = response.data[0];
            this.total = response.page.totalCount;
            this.totalsize = response.page.pageSize;
          }
        })
        .catch(error => {
          this.$router.push({ path: "/login" });
        });
    },
    onSubmit(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          RequestPost("/customer/update", this.form).then(response => {
            if (response.code == "0000") {
              this.$message({
                message: response.message,
                type: "success"
              });
              this.loadData();
            } else {
              this.$message({
                message: response.message,
                type: "error"
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleChange() {}
  },

  //初始化数据
  created: function() {
    this.loadData();
  }
};
</script>


// WEBPACK FOOTER //
// modify.vue?75ecefb0